import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SetBusinessSectionNotRelevantMutationVariables = Types.Exact<{
  payload: Types.SetBusinessSectionNotRelevantPayload;
}>;

export type SetBusinessSectionNotRelevantMutation = {
  __typename?: "Mutation";
  setBusinessSectionNotRelevant: {
    __typename?: "MutationResult";
    success: boolean;
  };
};

export const SetBusinessSectionNotRelevantDocument = gql`
  mutation setBusinessSectionNotRelevant(
    $payload: SetBusinessSectionNotRelevantPayload!
  ) {
    setBusinessSectionNotRelevant(payload: $payload) {
      success
    }
  }
`;
export type SetBusinessSectionNotRelevantMutationFn = Apollo.MutationFunction<
  SetBusinessSectionNotRelevantMutation,
  SetBusinessSectionNotRelevantMutationVariables
>;

/**
 * __useSetBusinessSectionNotRelevantMutation__
 *
 * To run a mutation, you first call `useSetBusinessSectionNotRelevantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBusinessSectionNotRelevantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBusinessSectionNotRelevantMutation, { data, loading, error }] = useSetBusinessSectionNotRelevantMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetBusinessSectionNotRelevantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBusinessSectionNotRelevantMutation,
    SetBusinessSectionNotRelevantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBusinessSectionNotRelevantMutation,
    SetBusinessSectionNotRelevantMutationVariables
  >(SetBusinessSectionNotRelevantDocument, options);
}
export type SetBusinessSectionNotRelevantMutationHookResult = ReturnType<
  typeof useSetBusinessSectionNotRelevantMutation
>;
export type SetBusinessSectionNotRelevantMutationResult =
  Apollo.MutationResult<SetBusinessSectionNotRelevantMutation>;
export type SetBusinessSectionNotRelevantMutationOptions =
  Apollo.BaseMutationOptions<
    SetBusinessSectionNotRelevantMutation,
    SetBusinessSectionNotRelevantMutationVariables
  >;
